<template>
    <div class="position-relative">
        <hr>
        <loader-gif v-if="isRequestBooking" />
        <div class="row  mb-3">
            <div class="col-md-12">
                <h4 class="title-h4">
                   {{ i18n.t("views.clients.sessionBooking.title") }}
                </h4>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-12">
                <div v-if="sessionBookingsList?.length > 0" class="tab-pane fade in active show" id="session_bookings"
                    style="overflow-x: auto;">
                    <table class="table table-striped table-bordered">
                        <thead class="thead-dark">
                            <tr>
                                <th>{{ i18n.t('tables.sessionBooking.trainer') }}</th>
                                <th>{{ i18n.t("views.clients.sessionBooking.session_date") }}</th>
                                <th>{{ i18n.t("views.clients.sessionBooking.start_time") }}</th>
                                <th>{{ i18n.t("views.clients.sessionBooking.end_time") }}</th>
                                <th>{{ i18n.t("views.clients.sessionBooking.booking_status") }}</th>
                                <th>{{ i18n.t("views.clients.sessionBooking.attendance_status") }}</th>
                                <th>{{ i18n.t("tables.action") }}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="booking in sessionBookingsList" :key="`booking-${booking?.id}`">

                                <td>{{ booking.trainer?.name ?? "-" }} </td>
                                <td>{{ formatDate(booking.session_date) }}</td>
                                <td>{{ booking.start_time }}</td>
                                <td>{{ booking.end_time }}</td>
                                <td>{{ booking.booking_status }}</td>
                                <td>
                                    <span v-if="booking.attendance_status === 'pending'">
                                        <button type="button" class="btn btn-sm btn-success me-1"
                                            @click="markAttendance(booking.id, 'completed')">
                                            {{ i18n.t("views.clients.sessionBooking.present") }}
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger"
                                            @click="markAttendance(booking.id, 'absent')">
                                            {{ i18n.t("views.clients.sessionBooking.absent") }}
                                        </button>
                                    </span>
                                    <span v-else>{{ booking.attendance_status }}</span>
                                </td>
                                <td>
                                    <btn-delete v-if="hasPermission('delete_member_session_booking')"
                                        @delete="deleteSessionItem(booking?.id)" />
                                    <!-- <btn-edit @edit="emiEditBooking(booking)" /> -->
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, computed, PropType } from "vue";

/*plugins*/
import Swal from "sweetalert2";
import i18n from "@/i18n/index"

import { useSessionBookings } from "@/composables/sessionBooking/useSessionBookings";
import { useGlobal } from "@/composables/global/useGlobal";
import { usePermission } from "@/composables/auth/usePermission";

import { Income } from "@/interfaces/income";

import { sessionBookings, singleIncome } from "@/shared/state";

export default defineComponent({
    components: {},
    name: "list-session-bookings",
    emits: ['saved', 'editBooking'],
    props: {

    },

    setup(props, { emit }) {
        const { hasPermission } = usePermission();
        const { formatDate } = useGlobal();
        const {
            markAttendance: doMarkAttendance, isRequestBooking, deleteBooking
        } = useSessionBookings();

        const sessionBookingsList = computed(() => sessionBookings?.data ?? []);
        const singleIncomeList = computed(() => singleIncome?.data ?? []);

        const deleteSessionItem = (id: number) => {
            Swal.fire({
                title: i18n.t("message.confirmation.delete.title"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: i18n.t("button.delete"),
                cancelButtonText: i18n.t("button.cancel"),
            }).then(async (result) => {
                if (result.isConfirmed) {
                    console.log(id)
                    deleteBooking(id).then(res => {
                        if (res == true) {
                            emit('saved');
                        }
                    })


                }
            });
        };

        const markAttendance = async (
            bookingId: number,
            status: "completed" | "absent"
        ) => {
            Swal.fire({
                title: i18n.t("message.confirmation.delete.title"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: i18n.t("button.delete"),
                cancelButtonText: i18n.t("button.cancel"),
            }).then(async (result) => {
                if (result.isConfirmed) {

                    await doMarkAttendance({ booking_id: bookingId, attendance_status: status }).then(res => {
                        if (res == true) {
                            emit('saved');
                        }
                    })

                }
            });


        };

        /**
          * Pour sessionBooking
          */
        const emiEditBooking = (booking: any) => {

            emit('editBooking', booking)
        };


        return {
            singleIncomeList,
            markAttendance,
            emiEditBooking,
            isRequestBooking,
            hasPermission,
            deleteSessionItem,
            sessionBookingsList,
            // initStateBilan,
            i18n,
            formatDate
        };
    }
});
</script>